<template>
  <div class="yiContainer">
    <div class="section">
      <!-- 导航 -->
      <div class="navBar">
        <img class="navLogo" src="../assets/logo2.png" alt="" @click="enterHome()" />
        <ul class="navBarItem">
          <!-- <li class="busiz-active-sel">
            <router-link exact to="/" tag="a">首页</router-link>
          </li> -->
          <li>
            <router-link to="/aboutlanshu" exact tag="a">关于兰树</router-link>
          </li>
          <el-dropdown>
            <li class="brandLi">
              <router-link exact to="/huaiBrand" style="font-size: 1em" tag="a">兰树品牌</router-link>
            </li>
            <el-dropdown-menu class="elDropdown" exact slot="dropdown"
              style="background: rgb(236, 245, 255) !important">
              <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '1' ? 'elDropdown_active' : ''"
                    style="background: rgb(236, 245, 255) !important; color: #000 !important; " to="/huaiBrand" tag="a">
                    淮树</router-link>
                </li>
              </el-dropdown-item>
              <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '2' ? 'elDropdown_active' : ''"
                    style="background: rgb(236, 245, 255) !important; color: #000 !important; " to="/brand" tag="a">心清堂
                  </router-link>
                </li>
              </el-dropdown-item>
              <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '3' ? 'elDropdown_active' : ''"
                    style="background: rgb(236, 245, 255) !important; color: #000 !important; " to="/shuiBrand" tag="a">
                    水姻缘</router-link>
                </li>
              </el-dropdown-item>
              <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '4' ? 'elDropdown_active' : ''"
                    style=" background: rgb(236, 245, 255) !important; color: #000 !important;" to="/yiBrand" tag="a">
                    一清堂</router-link>
                </li>
              </el-dropdown-item>
              <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '5' ? 'elDropdown_active' : ''"
                    style=" background: rgb(236, 245, 255) !important; color: #000 !important;" to="/zhongBrand"
                    tag="a">
                    <span>Dr.CHUNG<span style="vertical-align: super;">+</span></span></router-link>
                </li>
              </el-dropdown-item>
              <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '6' ? 'elDropdown_active' : ''"
                    style=" background: rgb(236, 245, 255) !important; color: #000 !important;" to="/lanshuBrand"
                    tag="a">兰树</router-link>
                </li>
              </el-dropdown-item>
              <el-dropdown-item>
                <li>
                  <router-link :class="brandActive == '7' ? 'elDropdown_active' : ''"
                    style=" background: rgb(236, 245, 255) !important; color: #000 !important;" to="/zbqfBrand"
                    tag="a">植本清方</router-link>
                </li>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <li><router-link to="/park" exact tag="a">智慧园区</router-link></li>
          <li>
            <router-link to="/brandLanshu" exact tag="a">美业菩提</router-link>
          </li>
          <li><router-link to="/school" exact tag="a">兰树商学院</router-link></li>

          <li>
            <router-link to="/dynamicLanshu" exact tag="a">菩提基金会</router-link>
          </li>

          <li>
            <router-link to="/lanshuTrends" exact tag="a">兰树动态</router-link>
          </li>
        </ul>
      </div>

      <div class="topImg">
        <img src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_14-15-11_91864.jpg" alt="">
      </div>
    </div>


    <div style="background:#fff;">
      <!-- 产品 故事 护肤 -->
      <div class="product">
        <div class="top_text">
          <span class="text_home">
            <router-link to="/yiBrand" style="text-decoration: none;color: #000;">首页</router-link>
          </span>
          <el-dropdown>
            <span class="text_product">产品</span>
            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item>
                <router-link to="/yiYellow" style="text-decoration: none;color: #000;">倾城秘颜眼部系列
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item>
                <router-link to="/yiPurple" style="text-decoration: none;color: #000;">嫱颜玉润精粹系列
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item>
                <router-link to="/yiWhite" style="text-decoration: none;color: #000;">美蝉光感蕴能系列</router-link>
              </el-dropdown-item>
              <el-dropdown-item>
                <router-link to="/yiRed" style="text-decoration: none;color: #000;">玉奴清滢平衡系列</router-link>
              </el-dropdown-item>
              <el-dropdown-item>
                <router-link to="/yiBlack" style="text-decoration: none;color: #000;">丽姬凝润冰肌系列</router-link>
              </el-dropdown-item>
              <el-dropdown-item>
							<router-link to="/yiNew" style="text-decoration: none;color: #000;">一清堂特品系列</router-link>
						</el-dropdown-item>

              <el-dropdown-item>
                <router-link :to="{ path: '/productsList', query: { brandId: 3 } }"
                  style="text-decoration: none;color: #000;">一清堂套盒系列</router-link>
              </el-dropdown-item>
              <el-dropdown-item>
                <router-link to="/yiClean" style="text-decoration: none;color: #000;">洁修养系列
                </router-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span class="text_story">
            <router-link to="/yiStory" style="text-decoration: none;color: #000;">故事</router-link>
          </span>
          <span class="text_skin">
            <router-link to="/yiSkin" style="text-decoration: none;color: #000;">护肤</router-link>
          </span>
          <!-- <span class="text_design">
					<router-link to="/yiDesign" style="text-decoration: none;color: #000;">设计</router-link>
				</span> -->
        </div>

        <div class="allProduct">
          <div style="height:185px;background: linear-gradient(to bottom, #9964DA , #ECEAF2 , #FCFCFD);">
          </div>
          <div class="showProduct con">
            <div class="detailProduct con1">
              <div class="detail">
                <div class="price" style="margin-left:15px;">¥428.00 ｜ 12片*25ML</div>
                <div class="line" style="margin-left:70px;"></div>
                <div class="name" style="margin-left:-18px;margin-top: 36px;">MOSTURIZING AND
                  DELICATE<br />FACIAL MASK<br /><span
                    style="font-family:PingFangSC-Light, PingFang SC;">一清堂凝润冰肌面膜</span>
                </div>
                <div class="cover">
                  <img height="181px" src="../assets/yiBrand/black/product1.png" alt="">
                </div>
              </div>
              <div class="detail" style="margin-left: -10px;">
                <div class="price" style="margin-left:-45px;">¥238.00 ｜ 120ML</div>
                <div class="line" style="margin-left:10px;"></div>
                <div class="name" style="margin-left:-36px; margin-top: 35px;">MOSTURIZING AND<br />DELICATE
                  TONER<br /><span style="font-family:PingFangSC-Light, PingFang SC;">一清堂凝润冰肌水</span></div>
                <div class="cover" style="margin-left:4px;">
                  <img height="184px" src="../assets/yiBrand/black/product2.png" alt="">
                </div>
              </div>
              <div class="detail" style="margin-left: 40px;">
                <div class="price" style="margin-left:-30px;">¥980.00 | 80ML</div>
                <div class="line" style="margin-left:18px;"></div>
                <div class="name" style="margin-left:-66px;margin-top: 36px;">MOSTURIZING AND
                  DELICATE<br />COLLAGENIC SERUM<br /><span
                    style="font-family:PingFangSC-Light, PingFang SC;">一清堂凝润冰肌胶原蛋白液</span></div>
                <div class="cover" style="margin-left:17px;">
                  <img style="height:170px;" src="../assets/yiBrand/black/product3.png" alt="">
                </div>
              </div>
              <div class="detail">
                <div class="price" style="margin-left:-30px;">¥498.00 ｜ 80ML</div>
                <div class="line" style="margin-left:22px;"></div>
                <div class="name" style="margin-left:-26px; margin-top: 36px;">MOSTURIZING AND<br />DELICATE
                  SERUM<br /><span style="font-family:PingFangSC-Light, PingFang SC;">一清堂凝润冰肌精华液</span></div>
                <div class="cover" style="margin-left:13px;">
                  <img style="height:170px;" src="../assets/yiBrand/black/product4.png" alt="">
                </div>
              </div>
              <div class="detail">
                <div class="price" style="margin-left:10px;">¥268.00 | 50G</div>
                <div class="line" style="margin-left:58px;"></div>
                <div class="name" style="margin-left:-24px; margin-top: 32px;">MOSTURIZING AND
                  DELICATE<br />BEDTIME FACIAL MASK<br /><span
                    style="font-family:PingFangSC-Light, PingFang SC;">一清堂凝润冰肌睡眠面膜</span>
                </div>
                <div class="cover" style="margin-left:26px;">
                  <img style="height:106px;" src="../assets/yiBrand/black/product5.png" alt="">
                </div>
              </div>

              <div class="detail" style="margin-left:20px;">
                <div class="price" style="margin-left:-90px;">¥1280.00 ｜ 冻干粉100MGx10瓶&溶媒液3MLx10瓶
                </div>
                <div class="line" style="margin-left:34px;"></div>
                <div class="name" style="margin-left:-44px; margin-top: 34px;">MOISTURIZING AND
                  DELICATE<br />LYOPHILIZED POWDER<br /><span
                    style="font-family:PingFangSC-Light, PingFang SC;">一清堂凝润冰肌冻干粉+溶媒液</span>
                </div>
                <div class="cover" style="margin-left:12px;">
                  <img height="80px" src="../assets/yiBrand/black/product6.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>

      <!-- 品牌文化 -->
      <div class="customer con">
        <div class="content">
          <div class="left">
            <div class="top-title">
              花开几度春 玉面如初见
            </div>
            <div class="center-title">
              留驻时光，御美有术。<br /><br />
              适用人群：<span style="font-family:PingFangSC-Thin, PingFang SC;">轻熟肌</span><br />
              适用肤质：<span style="font-family:PingFangSC-Thin, PingFang SC;">油性及中干性肌肤</span><br />
            </div>
            <div class="bottom-title">
              一贴赋能，润泽肌底：<span style="font-family:PingFangSC-Thin, PingFang SC;">凝润冰肌面膜12片*25ml</span><br />
              沁透凝肤，嘭润上扬：<span style="font-family:PingFangSC-Thin, PingFang SC;">凝润冰肌水*120ml</span><br />
              嘭润补水，丰盈焕肤：<span style="font-family:PingFangSC-Thin, PingFang SC;">凝润冰肌精华液*80ml</span><br />
              胶原嘭弹，莹润满级：<span style="font-family:PingFangSC-Thin, PingFang SC;">凝润冰肌胶原蛋白液*80ml</span><br />
              高阶润泽，加乘修润：<br /><span
                style="font-family:PingFangSC-Thin, PingFang SC;">凝润冰肌冻干粉100mg*10瓶+溶媒液3ml*10瓶</span><br />
              凝萃补水，唤启光采：<span style="font-family:PingFangSC-Thin, PingFang SC;">凝润冰肌睡眠面膜*50g</span><br />
            </div>
          </div>
          <div class="right">
            <div class="title">
              丽姬凝润冰肌系列
            </div>
            <!-- 轮播图 -->
            <div class="content">

              <div class="prev">
                <img src="../assets/yiBrand/prev.png" @click="Click('prev')" />
              </div>
              <div class="carousel">
                <el-carousel arrow="never" interval="2000" height="510px" :autoplay="true" indicator-position="none"
                  ref="imgShow">
                  <el-carousel-item v-for="(item, index) in productlist" :key="index">
                    <div class="cover">
                      <img :src="item.img" alt="">
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <div class="next">
                <img src="../assets/yiBrand/next.png" @click="Click('next')" />
              </div>
            </div>
          </div>
        </div>

        <div class="allProduct con" style="margin-left:-20px;">
          <div class="detail" style="margin-right:30px;">
            <div class="price" style="margin-left:6px;">120ML / 4.2FL.OZ</div>
            <div class="line"></div>
            <div class="name" style="margin-top: 20px;">MOISTURIZING<br>ESSENTIAL
              TONER<br><span style="font-family:PingFangSC-Light, PingFang SC;">一清堂玉润精萃水</span></div>
            <!-- <div class="star" style="margin-left:-14px;margin-top: 26px;">•明星甄选•</div> -->
            <div class="cover" style="margin-left:38px;">
              <img style="height:228px;" src="../assets/yiBrand/red/product1.png" alt="">
            </div>
          </div>
          <div class="detail" style="margin-right:30px;">
            <div class="price" style="margin-left:7px;">120ML / 4.2FL.OZ</div>
            <div class="line"></div>
            <div class="name" style="margin-top:20px ;">YIQINGTNAG<br>CLEAR
              CLEANSER<br><span style="font-family:PingFangSC-Light, PingFang SC;">一清堂清滢洁面露</span></div>
            <!-- <div class="star" style="margin-left:-3px; margin-top: 26px;">•明星甄选•</div> -->
            <div class="cover" style="margin-left:38px;">
              <img style="height: 228px;" src="../assets/yiBrand/red/product2.png" alt="">
            </div>
          </div>
          <div class="detail" style="width: 221px;margin-right:30px;">
            <div class="price" style="margin-left:17px;">12片*25ML / 0.88FL.OZ</div>
            <div class="line"></div>
            <div class="name" style="margin-top: 20px;">MOISTURIZING ESSENTIAL<br />FACIAL
              MASK<br /><span style="font-family:PingFangSC-Light, PingFang SC;">一清堂玉润精萃面膜</span>
            </div>
            <!-- <div class="star" style="margin-left:54px;margin-top: 26px;">•明星甄选•</div> -->
            <div class="cover" style="margin-bottom:-2px;margin-left: 11px;">
              <img height="203px" src="../assets/yiBrand/red/product3.png" alt="">
            </div>
          </div>
          <div class="detail">
            <div class="price" style="margin-left:8px;">120ML / 4.2FL.OZ</div>
            <div class="line"></div>
            <div class="name" style="margin-top: 20px;">CLEAR
              BALANCING<br />TONER<br /><span style="font-family:PingFangSC-Light, PingFang SC;">一清堂清滢平衡水</span></div>
            <!-- <div class="star" style="margin-left:-18px;margin-top: 16px;">•明星甄选•</div> -->
            <div class="cover" style="margin-bottom:-16px;margin-left: 43px;">
              <img style="height: 252px;" src="../assets/yiBrand/red/product4.png" alt="">
            </div>





          </div>
        </div>
      </div>

      <!-- 系列推荐 -->
      <div class="recommend">
        <div class="title-wrap">
          <div class="name">系列推荐</div>
          <div class="en">PRODUCT SERIESV</div>
          <div class="line"></div>

        </div>
        <div class="content con">
          <!-- 轮播图 -->
          <div class="prev">
            <img src="../assets/yiBrand/prev.png" @click="arrowClick('prev')" />
          </div>
          <div class="carousel">
            <el-carousel arrow="never" height="510px" interval="2000" :autoplay="true" indicator-position="none"
              ref="cardShow">
              <el-carousel-item v-for="(item, index) in datalist" :key="index">
                <div class="box">
                  <div class="left">
                    <div class="cover" @click="goPage(item.color1)">
                      <img :src="item.img1" alt="">
                    </div>
                    <div class="name">{{ item.name1 }}</div>
                    <div class="more">
                      <span @click="goPage(item.color1)">查看更多</span>
                    </div>
                  </div>
                  <div class="right">
                    <div class="cover" @click="goPage(item.color2)">
                      <img :src="item.img2" alt="">
                    </div>
                    <div class="name">{{ item.name2 }}</div>
                    <div class="more">
                      <span @click="goPage(item.color2)">查看更多</span>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="next">
            <img src="../assets/yiBrand/next.png" @click="arrowClick('next')" />
          </div>

        </div>
      </div>




      <div class="section pageBox6">
        <div class="pageBoxOut2">
          <!-- 底部 -->
          <div class="footerBox">
            <div class="footerBoxHeader">
              <div class="footerBoxHeaderLeft">
                <img class="codeImg" src="../assets/code.png" alt="" />
                <span class="codeText">兰树公众号</span>
              </div>
              <div class="footerBoxHeaderCenter">
                <img class="codeImg" src="../assets/xcxNew.jpg" alt="" />
                <span class="codeText">兰树云小程序</span>
              </div>
              <div class="footerBoxHeaderRight">
                <img class="codeImg" src="../assets/yiBrand/yiqingtang.jpg" alt="">
                <span class="codeText">官方微信公众号</span>
              </div>
            </div>
            <div class="footerMainBox">
              <li class="footerShop"><a target="_blank"
                  href="https://huaishu.tmall.com/shop/view_shop.htm?spm=a230r.7195193.1997079397.2.124378dduXIhiW">淮树旗舰店</a>
              </li>
              <li class="footerShop"><a target="_blank"
                  href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">心清堂官方企业店</a>
              </li>
              <li class="footerShop"><a target="_blank" href="https://shop349169226.taobao.com/?spm=a21xtw.29978516.0.0">水姻缘旗舰店</a></li>
              <li class="footerShop"><a target="_blank"
                  href="https://shop537937985.taobao.com/?spm=a230r.7195193.1997079397.2.374448f3jcdl9s">一清堂官方企业店</a>
              </li>
              <li class="footerShop"><a target="_blank" href="https://drchung.tmall.com" ><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span>旗舰店</a></li>
              <li class="footerShop"><a target="_blank" href="https://zhibenqingfang.tmall.com">植本清方旗舰店</a></li>
              <div class="lastHeader">
                <li><router-link to="/login" tag="a">登录</router-link></li>
                |
                <li><router-link to="/login" tag="a">注册</router-link></li>
              </div>
            </div>

            <div class="footerInfoBox">
              <div class="emailBox">邮箱: postermaster@lasur.com</div>
              <div class="phoneBox">电话: 0571-89025888</div>
              <div class="addressBox">
                地址: 浙江省杭州市之江东路越秀·维多利中心A座 17楼
              </div>
            </div>

            <div class="footerLine"></div>
            <div class="footerBoxBottom">
              <div class="footerLeft">
                Copyright © 2023 兰树化妆品股份有限公司
                <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a> |
                <img height="16px" src="../assets/plice.png" />&nbsp;<a target="_blank"
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
                  33052102000740号</a>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      productlist: [
        { img: "https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-16_16-54-50_93706.jpeg" },

        { img: "https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-16_16-55-07_5490.jpeg" },

        { img: "https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-16_16-55-21_69175.jpeg" },

        { img: "https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-16_16-55-37_76629.jpeg" },

        { img: "https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-16_16-55-53_11196.jpeg" },

        { img: "https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-16_16-56-09_8341.jpeg" },

      ],
      datalist: [{
				img1: require("../assets/yiBrand/site-1.png"),
				name1: "倾城秘颜眼部系列",
				color1: "yellow",
				img2: require("../assets/yiBrand/site-2.png"),
				name2: "嫱颜玉润精粹系列",
				color2: "purple"
			},
			{
				img1: require("../assets/yiBrand/site-3.png"),
				name1: "美蝉光感蕴能系列",
				color1: "white",
				img2: require("../assets/yiBrand/site-4.png"),
				name2: "玉奴清滢平衡系列",
				color2: "red"
			},
			{
				img1: require("../assets/yiBrand/site-5.png"),
				name1: "丽姬凝润冰肌系列",
				color1: "black",
				img2: require("../assets/yiBrand/site-6.png"),
				name2: "一清堂套盒系列",
				color2: "old"
			},
			{
				img1: require("../assets/yiBrand/site-7.png"),
				name1: "一清堂特品系列",
				color1: "new",
				img2: require("../assets/yiBrand/site-8.png"),
				name2: "洁修养系列",
				color2: "clean"
			}

			],
      brandActive: 1,
    };
  },
  methods: {
    enterProducts(id) {
      this.$router.push({ path: "/productsList", query: { brandId: id } });
    },
    enterHome() {
      this.$router.push({ path: "/" });
    },
    arrowClick(val) {
      if (val === 'next') {
        this.$refs.cardShow.next()
      } else {
        this.$refs.cardShow.prev()
      }
    },
    Click(val) {
      if (val === 'next') {
        this.$refs.imgShow.next()
      } else {
        this.$refs.imgShow.prev()
      }
    },
    goPage(val) {
      switch (val) {
        case 'clean':
          this.$router.push({
            path: "/yiClean"
          })
          break;
        case 'red':
          this.$router.push({
            path: "/yiRed"
          })
          break;
        case 'purple':
          this.$router.push({
            path: "/yiPurple",
          })
          break;
        case 'black':
          this.$router.push({
            path: "/yiBlack",
          })
          break;
        case 'yellow':
          this.$router.push({
            path: "/yiYellow",
          })
          break;
        case 'white':
          this.$router.push({
            path: "/yiWhite",
          })
          break;
        case 'old':
          this.$router.push({
            path: '/productsList', query: { brandId: 3 }
          })
          break;
        case 'new':
					this.$router.push({
						path: '/yiNew',
					})
					break;
      }

    }
  },
};
</script>

<style scoped>
.yiContainer {
  width: 100%;
  overflow: hidden;
  margin: 0;
  padding: 0;
  position: relative;
}


/* 导航 */

/* 下拉菜单栏 选中 */
.navBar {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: absolute;
  justify-content: space-between;
  top: 0;
  background: #ffffff;
  z-index: 999;
}

.navLogo {
  width: 10%;
  margin-left: 5em;
  cursor: pointer;
}

.navBarItem {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.navBarItem li {
  /* list-style: none;
          padding: 1.5em 2.5em 1.5em 2.5em;
          float: left; */
  list-style: none;
  /* padding: 25px 40px 25px 40px; */
  float: left;
  /* margin-left: 2em; */
}

.brandLi a {
  text-decoration: none;
  font-size: 0.875em;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #222222;
  line-height: 20px;
  padding-top: 1.6em !important;
  padding-bottom: 1.6em !important;
  padding-left: 2em;
  padding-right: 2em;
}

.navBarItem li a {
  text-decoration: none;
  font-size: 0.875em;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #222222;
  line-height: 20px;
  padding-top: 1.4em;
  padding-bottom: 1.4em;
  padding-left: 1.4rem;
  padding-right: 1.4rem;
}


.elDropdown a {
  color: #111111;
  text-decoration: none;
}



.pageBoxOut2 {
  width: 90%;
  height: 100%;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  box-sizing: border-box;
}



/* pageBox6 */
.pageBox6 {
  margin-top: -150px;
  width: 100%;
  height: 653px;
  display: flex;
  flex-direction: column;
  color: #000;
  /* background-image: url(../assets/yiBrand/bg2.png); */
  background: linear-gradient(to top, #9D92BF, #ECEAF2, #FCFCFD, #fff);
}

/* footer */
.footerBox {
  width: 90%;
  /* height: 287px; */
  /* position:absolute;
             bottom:0; */
  margin: 0 auto;
  flex-direction: column;
  z-index: 999;
}

.footerBoxHeader {
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 2%;
}

.footerBoxHeaderLeft {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footerBoxHeaderCenter {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5em;
}

.footerBoxHeaderRight {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 5em;
}

.codeImg {
  width: 90px;
}

.codeText {
  font-size: 0.88em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #000;
  line-height: 20px;
  margin-top: 0.5rem;
}

.footerLine {
  width: 79%;
  height: 1px;
  display: flex;
  background: #000;
  opacity: 0.1;
  margin: 0 auto;
  align-items: center;
  margin-top: 1em;
}

.footerInfoBox {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
}

.emailBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #000;
  line-height: 20px;
}

.phoneBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #000;
  line-height: 20px;
  margin-top: 0.5rem;
}

.addressBox {
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #000;
  line-height: 20px;
  margin-top: 0.5rem;
}

.footerBoxBottom {
  display: flex;
  margin: 0 auto;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 1rem;
}

.footerLeft {
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #000;
  line-height: 24px;
}

.footerLeft a {
  text-decoration: none;
  cursor: pointer;
  color: #000;
}

.footerLeft a:hover {
  color: #000;
}

.lastHeader {
  display: flex;
  flex-direction: row;
  font-size: 0.875em;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #000;
  line-height: 28px;
  margin-left: 2em;
}

.lastHeader li a {
  text-decoration: none;
  font-size: 0.875rm;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #000;
  line-height: 28px;
}

.lastHeader li {
  list-style: none;
}

.footerMainBox {
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  margin-top: 2em;
}

.footerShop {
  list-style: none;
}

.footerShop a {
  text-decoration: none;
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 200;
  color: #000;
  padding-left: 2em;
  line-height: 28px;
  cursor: pointer;
}



/* 首图 */
.topImg {
  /* margin-top: 66px; */
  width: 100%;
  position: fixed;
  background-color: #fff;
  z-index: -1;
  max-height: 462px;
  transition-property: all;
  text-align: center;
}

.topImg img {
  /* width: 1920px; */
  width: 100%;
  height: 100%;
  /* height: 462px; */
}


/* 产品 故事 护肤 */
.product {
  margin-top: 46%;
  box-shadow: 0px -20px 50px white;
  /* margin-top: 644px; */
}

.product .top_text {
  padding-top: 20px;
  text-align: center;
  margin-bottom: 53px;
}

.product .top_text span {
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 100;
  color: #000000;
  letter-spacing: 1px;
}

.product .top_text .text_home {
  cursor: pointer;
  margin-right: 50px;
}


.product .top_text .text_product {
  cursor: pointer;
  margin-right: 50px;
  padding-bottom: 5px;
  border-bottom: 1px solid #979797;
}

.product .top_text .text_story {
  cursor: pointer;
  margin-right: 50px;
}

.product .top_text .text_skin {
  cursor: pointer;
  /* margin-right: 40px; */
}

.product .top_text .text_design {
  cursor: pointer;
}


.product .allProduct {
  /* position: relative; */
  height: 580px;
  /* background: linear-gradient(to bottom, #9D92BF, #ECEAF2, #FCFCFD); */
}

.product .allProduct .showProduct {
  position: relative;
  height: 400px;
  /* background-color: #3F3A60; */
}

.product .allProduct .showProduct .detailProduct {
  /* width: 1300px; */
  position: absolute;
  bottom: 92px;
  left: 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* background-color: #EBA998; */
}

.customer .allProduct .detail,
.product .allProduct .showProduct .detail {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-start;
}


.customer .allProduct .detail .star {
  height: 25px;
  line-height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Thin, PingFang SC;
  font-weight: 100;
  color: #000;
  letter-spacing: 1px;
}

.customer .allProduct .detail .name {
  height: 66px;
  line-height: 22px;
  font-size: 16px;
  text-align: center;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  letter-spacing: 1px;
  color: #000;
}

.product .allProduct .showProduct .detail .name {
  font-size: 14px;
  text-align: center;
  font-family: PingFangSC-Thin, PingFang SC;
  font-weight: 100;
  /* letter-spacing: 1px; */
  color: #000;
  height: 66px;
  line-height: 22px;
}

.customer .allProduct .detail .line,
.product .allProduct .showProduct .detail .line {
  width: 43px;
  height: 1px;
  background: #979797;
  margin: 15px auto 0px;
}

.customer .allProduct .detail .price {
  height: 22px;
  line-height: 22px;
  margin-top: 19px;
  text-align: center;
  font-family: PingFangSC-Thin, PingFang SC;
  font-size: 16px;
  font-weight: 100;
  color: #000;
}

.product .allProduct .showProduct .detail .price {
  height: 19px;
  line-height: 19px;
  margin-top: 14px;
  text-align: center;
  font-family: PingFangSC-Thin, PingFang SC;
  font-size: 16px;
  font-weight: 100;
  color: #000;
}




/* 品牌文化 */
.customer {
  margin-top: 80px;
  /* width: 100%; */
  height: 1156px;
  position: relative;

}


.customer .content .left {
  position: absolute;
  left: 42px;
  top: 143px;
}

.customer .content .left .top-title {
  font-size: 18px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #000000;
}

.customer .content .left .center-title {
  margin-top: 54px;
  height: 120px;
  line-height: 30px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #000000;
}

.customer .content .left .bottom-title {
  margin-top: 22px;
  height: 210px;
  line-height: 30px;
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #000000;
}


.customer .content .right {
  position: absolute;
  left: 721px;
  top: 62px;
  display: flex;
  flex-direction: row;
}

.customer .content .right .title {
  /* writing-mode: tb-rl; */
  font-size: 18px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #000000;
  width: 16px;
  height: 200px;
  line-height: 25px;
}

.customer .content .right .content {
  position: relative;
}

.customer .content .right .content .prev {
  position: absolute;
  left: 34px;
  top: 240px;
  z-index: 999;
  cursor: pointer;
}

.customer .content .right .content .next {
  position: absolute;
  left: 500px;
  top: 240px;
  z-index: 999;
  cursor: pointer;
}

.customer .content .right .content .prev img {
  width: 40px;
  height: 40px;
}

.customer .content .right .content .next img {
  width: 40px;
  height: 40px;
}

.customer .content .right .content .carousel {
  position: absolute;
  top: 2px;
  left: 104px;
  width: 363px;
  height: 543px;
}

.customer .content .right .content .carousel .cover {
  width: 363px;
  height: 543px;
  overflow: hidden;
}

.customer .content .right .content .carousel .cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.2s;
}

.customer .content .right .content .carousel .cover img:hover {
  transform: scale(1.1);
}


.customer .allProduct {
  position: absolute;
  top: 638px;
  left: 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}


/* 系列推荐 */
.recommend {
  margin-top: 66px;
  height: 685px;
  /* background-color: #A48D29; */
}



.recommend .title-wrap {
  text-align: center;
  /* color: #A48D29; */
  margin-bottom: 20px;
}



.recommend .title-wrap .name {
  height: 33px;
  font-size: 24px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #A48D29;
  line-height: 33px;
}


.recommend .title-wrap .en {
  font-family: PingFangSC-Thin, PingFang SC;
  font-size: 16px;
  margin-top: 3px;
  height: 22px;
  line-height: 22px;
  letter-spacing: 2px;
  color: #A48D29;
}


.recommend .title-wrap .line {
  width: 34px;
  height: 1px;
  background-color: #A48D29;
  margin: auto;
  margin-top: 10px;
}


.recommend .content {
  position: relative;
}

.recommend .content .prev {
  position: absolute;
  left: 66px;
  top: 30%;
  z-index: 999;
  cursor: pointer;

}

.recommend .content .prev img {
  width: 40px;
  height: 40px;
}

.recommend .content .next {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 66px;
  top: 30%;
  z-index: 999;
  cursor: pointer;
}

.recommend .content .next img {
  width: 40px;
  height: 40px;
}

.recommend .content .box {
  padding: 0 125px;
  display: flex;
  justify-content: space-between;
}

.recommend .content .cover {
  margin-top: 20px;
  width: 518px;
  height: 332px;
  overflow: hidden;
}

.recommend .content .cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: 0.2s;
  cursor: pointer;
}

.recommend .content .cover img:hover {
  transform: scale(1.1);
}

.recommend .content .box .name {
  height: 29px;
  font-size: 21px;
  margin-top: 10px;
  text-align: center;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #595857;
  line-height: 29px;
}

.recommend .content .box .more {
  margin-top: 17px;
}

.recommend .content .box .more span {
  width: 105px;
  height: 27px;
  font-size: 15px;
  font-family: PingFangSC-Thin, PingFang SC;
  line-height: 27px;
  padding: 3px 21px 2px 21px;
  border: 1px solid #c1c1c1;
  cursor: pointer;
  margin: 0px 208px;
}


/* .brand .content .card .more::after {
          content: '';
          display: block;
          width: 56px;
          margin: auto;
          height: 1px;
          background-color: #a69e9c;
          margin-top: 2px;
      } */

.con {
  width: 1300px;
  margin: 0 auto;
}

.con1 {
  width: 1450px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/yiBlack.vue